export class FoundQuantityDialogModel {
  constructor(public adnId: any, public invoices: any, public currDataType: any) {}
}
